<template>
  <FormSelect :options="employeeList" v-model="currentEmployeeId" />
</template>

<script>
import api from '@/Util/api';

export default {
  props: {
    modelValue: {},
  },
  data: ()=>({
    employees: [],
  }),
  computed: {
    employeeList() {
      var list=[
        ...this.employees.map(client=>({
          value: client.uuid,
          text: client.title,
        })),
      ];
      return list;
    },
    currentEmployeeId: {
      get() {
        return this.modelValue || "";
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  methods: {
    async loadEmployees() {
      this.employees=await api.list("Zaposleni", [
        ["klijent", "=", this.stores.auth.currentClient?.uuid],
      ]);
    },
  },
  created() {
    this.loadEmployees(); // TODO refresh
  },
}
</script>
